import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  q: string;
  a: string;
}
const faqs: FAQItem[] = [{
  q: '¿Es un libro físico?',
  a: 'Es un Pack 100% Digital. Podrás descargarlo inmediatamente en tu Celular, Tablet o PC y empezar hoy mismo.'
}, {
  q: '¿Funciona con adolescentes?',
  a: 'Sí. El método incluye estrategias diferenciadas para niños pequeños y adolescentes hasta los 17 años.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Al completar tu pago, recibirás un correo electrónico automático con los enlaces de descarga de los 4 archivos PDF.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <Section background="white" data-id="element-22">
      <h2 className="text-2xl font-bold text-[#1e3a5f] mb-6 text-center" data-id="element-23">
        Preguntas Frecuentes
      </h2>
      <div className="space-y-3 max-w-xl mx-auto" data-id="element-24">
        {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-25">
            <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-26">
              <span className="font-semibold text-[#1e3a5f] text-sm md:text-base pr-4" data-id="element-27">
                ❓ {faq.q}
              </span>
              <motion.div animate={{
            rotate: open === i ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="shrink-0" data-id="element-28">
                <ChevronDown className="w-5 h-5 text-[#1e3a5f]" data-id="element-29" />
              </motion.div>
            </button>
            <AnimatePresence data-id="element-30">
              {open === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25
          }} className="overflow-hidden" data-id="element-31">
                  <div className="px-4 pb-4 pt-1 bg-gray-50 text-[#2d3748] text-sm leading-relaxed border-t border-gray-100" data-id="element-32">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}